var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowerError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 92,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.006 28.63C1.37 30.813-1.44 37.15.736 42.788v.005l10.216-3.946c5.638-2.181 8.446-8.52 6.27-14.156v-.005L7.006 28.63zm21.911 32.072c5.637 2.181 8.446 8.52 6.27 14.156v.005L24.97 70.917c-5.647-2.181-8.451-8.52-6.275-14.157v-.004l10.22 3.946z",
    fill: "#FF6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.84 20.436C54.84 10.255 46.59 2 36.414 2h-.02c-10.176 0-18.426 8.255-18.426 18.436V90",
    stroke: "#FF6E6E",
    strokeWidth: 3.489,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.478 46.676a2.11 2.11 0 0 0 2.372 2.09c8.538-1.002 15.573-7.98 16.587-16.587.092-.754.144-1.52.144-2.297.005.777.051 1.543.143 2.297 1.014 8.607 8.05 15.58 16.587 16.587a2.11 2.11 0 0 0 2.372-2.09V31.92c.052-.697.029-1.37.023-2.033 0-10.553-8.55-19.102-19.091-19.102h-.023c-10.547 0-19.091 8.555-19.091 19.102.08 1.325-.098 15.597-.023 16.789z",
    fill: "#FF6E6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerError);
export default __webpack_public_path__ + "static/media/flowerError.bc12b5f3010a8701cdc1a9fb71a5e291.svg";
export { ForwardRef as ReactComponent };